<template>
  <div class="hello">
    <div>
      <md-dialog :md-active.sync="showDialog" class="dialog">
        <h2>{{ _("dialogHeader") }}</h2>
        <p>{{ _("dialogText") }}</p>
        <p>
          {{ _("dialogFooter1") }}
          <br />
          {{ _("dialogFooter2") }}
          <br />
          {{ _("dialogFooter3") }}
        </p>
        <md-dialog-actions>
          <md-button class="md-primary md-raised" @click="showDialog = false">{{
            _("close")
          }}</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>
    <form novalidate class="md-layout" @submit.prevent="validateForm">
      <md-card class="md-layout-item md-size-70 md-small-size-100">
        <md-card-header class="md-header">
          <!-- <md-field>
            <label>{{ _("language") }}</label>
            <md-select
              v-model="selectedLanguage"
              id="language"
              name="language"
              md-dense
              @md-selected="onLanguageSelect"
              :disabled="sending"
            >
              <md-option
                v-for="language in languages"
                :value="language.code"
                :key="language.code"
                >{{ language.name }}</md-option
              >
            </md-select>
          </md-field> -->
          <div class="md-title">{{ _("title") }}</div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item xsmall-size-100 mr-right-10">
              <md-field :class="getValidationClass('project')">
                <label>{{ _("object") }} *</label>
                <md-select
                  v-model="form.project"
                  id="project"
                  name="project"
                  md-dense
                  @md-selected="onObjectSelect"
                  :disabled="sending"
                >
                  <md-option
                    v-for="project in projects"
                    :value="project"
                    :key="project"
                    >{{ _(project) }}</md-option
                  >
                </md-select>
                <span class="md-error" v-if="!$v.form.project.required">{{
                  _("requiredField")
                }}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-size-30 xsmall-size-100 mr-right-10">
              <md-field :class="getValidationClass('apartmentNr')">
                <label for="apartmentNr">{{ _("flatNr") }}</label>
                <md-input
                  class="md-size-30"
                  name="apartmentNr"
                  id="apartmentNr"
                  v-model="form.apartmentNr"
                  :disabled="sending"
                  @input="checkApartmentError"
                />
                <span class="md-error" v-if="!$v.form.apartmentNr.numeric">{{
                  _("enterFlatNr")
                }}</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter" v-if="showObjectName">
            <div class="md-layout-item xsmall-size-100">
              <md-field :class="getValidationClass('objectName')">
                <label for="object name">{{ _("objectName") }} *</label>
                <md-input
                  name="form.objectName"
                  id="objectName"
                  v-model="form.objectName"
                  :disabled="sending"
                  @input="checkObjectNameError"
                />
                <span class="md-error" v-if="!$v.form.objectName.required">{{
                  _("requiredField")
                }}</span>
                <!-- <span class="md-error" v-if="!$v.showObjectName">TEST {{ _("requiredField") }}</span> -->
                <span
                  class="md-error"
                  v-else-if="!$v.form.objectName.alphaSpace"
                  >{{ _("lettersAndSpacesAllowed") }}</span
                >
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item xsmall-size-100">
              <md-field :class="getValidationClass('fullName')">
                <label for="full name">{{ _("firstAndLastName") }} *</label>
                <md-input
                  name="form.fullName"
                  id="fullName"
                  v-model="form.fullName"
                  :disabled="sending"
                  @input="checkNameError"
                />
                <span class="md-error" v-if="!$v.form.fullName.required">{{
                  _("requiredField")
                }}</span>
                <span
                  class="md-error"
                  v-else-if="!$v.form.fullName.alphaSpace"
                  >{{ _("lettersAndSpacesAllowed") }}</span
                >
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div
              class="md-layout-item md-size-15 xsmall-size-100 mr-right-10"
              v-bind:style="{ width: '100px' }"
            >
              <md-field :class="getValidationClass('region')">
                <label>{{ form.region }}</label>
                <md-select
                  class="md-size-15"
                  v-model="form.region"
                  id="region"
                  name="region"
                  v-bind:style="{ width: '130px' }"
                >
                  <md-option
                    v-for="region in regions"
                    :value="region"
                    :key="region"
                    >+{{ region }}</md-option
                  >
                </md-select>
              </md-field>
              <!--    <vue-country-code @onSelect="onSelect"></vue-country-code>-->
            </div>
            <div class="md-layout-item xsmall-size-100 mr-left-10">
              <md-field :class="getValidationClass('phoneNr')">
                <label for="phoneNr">{{ _("phoneNr") }} *</label>
                <md-input
                  name="phoneNr"
                  id="phoneNr"
                  v-model="form.phoneNr"
                  :disabled="sending"
                  @input="checkPhoneError"
                />
                <span class="md-error" v-if="!$v.form.phoneNr.required">{{
                  _("requiredField")
                }}</span>
                <span class="md-error" v-else-if="!$v.form.phoneNr.numeric">{{
                  _("onlyNumbersAllowed")
                }}</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item xsmall-size-100">
              <md-field :class="getValidationClass('email')">
                <label for="email">{{ _("email") }} *</label>
                <md-input
                  type="email"
                  name="email"
                  id="email"
                  autocomplete="email"
                  v-model="form.email"
                  :disabled="sending"
                  @input="checkEmailError"
                />
                <span class="md-error" v-if="!$v.form.email.required">{{
                  _("requiredField")
                }}</span>
                <span class="md-error" v-else-if="!$v.form.email.email">{{
                  _("emailNotValid")
                }}</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item xsmall-size-100">
              <div :class="getValidationClass('inspectionTime')">
                <md-datepicker
                  id="inspectionTime"
                  v-model="form.inspectionTime"
                  ref="inspectionTime"
                  name="form.inspectionTime"
                  md-immediately
                  @input="checkInspectionError"
                  :disabled="sending"
                  :md-disabled-dates="disabledDates"
                >
                  <label
                    :style="{
                      color: $v.form.inspectionTime.$error ? 'red' : 'initial',
                    }"
                    for="inspectionTime"
                  >
                    {{ _("inspectionDateFrom") }} *
                  </label>
                </md-datepicker>
                <span
                  class="md-error errorMsg"
                  v-if="
                    !$v.form.inspectionTime.required &&
                    $v.form.inspectionTime.$dirty
                  "
                  >{{ _("requiredField") }}</span
                >
                <span
                  class="md-error errorMsg"
                  v-else-if="!$v.form.inspectionTime.isDateValid"
                  >{{ _("fixDateFormat") }}</span
                >
              </div>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item xsmall-size-100">
              <div :class="getValidationClass('caseDueDate')">
                <md-datepicker
                  id="caseDueDate"
                  v-model="form.caseDueDate"
                  ref="caseDueDate"
                  name="form.caseDueDate"
                  md-immediately
                  @input="checkCaseDueDateError"
                  :disabled="sending"
                >
                  <label
                    :style="{
                      color:
                        this.caseDueDateInputDate &&
                        !this.$v.form.caseDueDate.isDateValid
                          ? 'red'
                          : 'initial',
                    }"
                    for="caseDueDate"
                  >
                    {{ _("caseDueDate") }}
                  </label>
                </md-datepicker>
                <span
                  class="md-error errorMsg"
                  v-if="
                    this.caseDueDateInputDate &&
                    !this.$v.form.caseDueDate.isDateValid
                  "
                  >{{ _("fixDateFormat") }}</span
                >
              </div>
            </div>
          </div>

          <div class="md-layout md-gutter top-margin">
            <md-checkbox
              v-model="multipleCases"
              :disabled="sending"
              class="checkbox md-primary"
              >{{ _("warrantyEndList") }}</md-checkbox
            >
          </div>
          <div class="md-layout md-gutter">
            <md-checkbox
              v-model="singleCase"
              class="checkbox md-primary"
              :disabled="sending"
              >{{ _("singleCase") }}</md-checkbox
            >
          </div>
          <div class="md-layout custom-layout">
            <h3
              v-if="multipleCases"
              class="complaint-header md-layout-item md-size-25"
            >
              {{ _("problemsByRow") }}
            </h3>
            <h3 v-else class="complaint-header md-layout-item md-size-25">
              {{ _("problemInfo") }}
            </h3>
            <span class="complaint-helptext md-layout-item">{{
              _("fileMaxSize")
            }}</span>
          </div>
          <SingleComplaint
            v-for="(thing, index) in complaintNumber"
            :key="index"
            :complaintNumber="complaintNumber"
            @user-input-changed="updateForm"
            @delete-complaint-row="deleteComplaint"
            :multipleCases="multipleCases"
            :emptyRows="emptyRows"
            :deleteRow="deleteRow"
            :_="_"
          ></SingleComplaint>
          <div>
            <md-button
              v-bind:class="{ show: multipleCases }"
              class="next-complaint-btn hidden"
              v-on:click="addComplaintRow"
              :disabled="sending"
              >{{ _("addNewRow") }}</md-button
            >
          </div>
        </md-card-content>
        <div class="before-send-helptext">
          <div>
            {{ _("beforeSendRow1") }}<br />
            {{ _("beforeSendRow2") }}
          </div>
        </div>
        <md-progress-bar md-mode="indeterminate" v-if="sending" />
        <md-card-actions>
          <vue-recaptcha
            ref="invisibleRecaptcha"
            @verify="onVerify"
            @expired="onExpired"
            size="invisible"
            :sitekey="sitekey"
          ></vue-recaptcha>

          <md-button
            id="submitButton"
            type="submit"
            class="md-raised"
            :disabled="sending"
          >
            <md-icon>send</md-icon>{{ _("send") }}
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import SingleComplaint from "./SingleComplaint.vue";
import VueRecaptcha from "vue-recaptcha";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  email,
  numeric,
  helpers,
} from "vuelidate/lib/validators";
import {
  MdCard,
  MdField,
  MdCheckbox,
  MdButton,
  MdProgress,
  MdMenu,
  MdList,
  MdDialog,
  MdDatepicker,
} from "vue-material/dist/components";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import appService from "../app.service";
import { getPreferredLanguage } from '../helpers/preferredLanguageHelper'
import i18nET from "../loc/et.json";
import i18nEN from "../loc/en.json";
import i18nRU from "../loc/ru.json";
import i18nLV from "../loc/lv.json";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

Vue.use(MdCard);
Vue.use(MdField);
Vue.use(MdCheckbox), Vue.use(MdButton);
Vue.use(MdProgress);
Vue.use(MdMenu);
Vue.use(MdList);
Vue.use(MdDialog);
Vue.use(MdDatepicker);

const alphaSpace = helpers.regex(
  "",
  /^[0-9a-zA-ZöäüõÖÄÜÕ ]+(([',. -][0-9a-zA-ZöäüõÖÄÜÕ ])?[0-9a-zA-ZöäüõÖÄÜÕ ]*)*$/
);

export default {
  name: "WebForm",
  components: { VueRecaptcha, SingleComplaint },
  mixins: [validationMixin],

  data: () => ({
    sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    showDialog: false,
    complaintNumber: 0,
    index: 0,
    showObjectName: false, //if TRUE shows the object name filed
    inspectionTimeInputDate: "",
    caseDueDateInputDate: "",
    form: {
      project: null,
      objectName: null,
      apartmentNr: null,
      fullName: null,
      inspectionTime: null,
      caseDueDate: null,
      phoneNr: null,
      email: null,
      region: "+372",
      complaintRows: {},
    },
    emptyRows: [],
    selectedLanguage: "ET",
    languageLibrary: i18nET,
    languages: [
      { name: "Eesti", code: "ET" },
      { name: "Русский", code: "RU" },
      { name: "Latviski", code: "LV" },
      { name: "English", code: "EN" },
    ],
    projects: [
      "notInList",
      "Ankru 8",
      "Elijas 26",
      "IBIS",
      "Kaselaane 7/1",
      "Kaselaane 7/2",
      "Kaselaane 9/1",
      "Kaselaane 9/2",
      "Kodu tee 1",
      "Linnamäe 38b",
      "Linnamäe tee 42a/1",
      "Linnamäe tee 42a/2",
      "Linnamäe tee 42a/3",
      "Maskavas 31",
      "Maskavas 33",
      "Maskavas 35",
      "Otsa tee 1",
      "Otsa tee 3",
      "Otsa tee 5",
      "Otsa tee 7",
      "Pirita tee 26d",
      "Remmelga 4",
      "Rõugu 22",
      "Rõugu 24",
      "Saadu 1",
      "Saadu 3",
      "Saadu 5",
      "Saadu 7",
      "Saadu 9",
      "Saadu 11",
      "Vallikraavi 14",
      "Viieaia tee 11/1",
      "Viieaia tee 11/2",
      "Viieaia tee 11/3",
      "Viieaia tee 28",
      "Võistluse 3",
    ],
    regions: [],
    userSaved: false,
    sending: false,
    lastUser: null,
    singleCase: true,
    multipleCases: false,
    deleteRow: null,
    datepickerError: false,
    disabledDates: (date) => date <= new Date(),
  }),
  validations: {
    form: {
      project: {
        required,
      },
      apartmentNr: {
        numeric,
      },
      fullName: {
        required,
        alphaSpace,
      },
      objectName: {
        required: requiredIf(function () {
          console.log("req: " + this.showObjectName);
          return this.showObjectName;
        }),
        alphaSpace,
      },
      inspectionTime: {
        required() {
          return !!this.inspectionTimeInputDate;
        },
        isDateValid(value) {
          if (!value && !this.inspectionTimeInputDate) return true;
          return this.hackValidateDate("inspectionTime");
        },
      },
      caseDueDate: {
        isDateValid(value) {
          if (!value && !this.caseDueDateInputDate) {
            return true;
          } else if (!value && this.caseDueDateInputDate) {
            return false;
          }
          return this.hackValidateDate("caseDueDate");
        },
      },
      phoneNr: {
        required,
        numeric,
      },
      email: {
        required,
        email,
      },
    },
  },
  created() {
    //TODO disable old dates
    this.getReport();
    this.addComplaintRow();
    // Show success message after form saved
    const formSaved = localStorage.getItem("formSaved");
    if (formSaved === "true") {
      localStorage.removeItem("formSaved");
      this._data.showDialog = true;
    }
  },
  watch: {
    singleCase: function (newVal) {
      this._data.multipleCases = !newVal;
      if (newVal === true) {
        const complaints = this.complaintNumber;
        // leave only one complaint row when switched bach to single case
        if (this.complaintNumber > 1) {
          for (let i = complaints; i > 1; i--) {
            this.deleteRow = this.complaintNumber;
            this.deleteComplaint(this.complaintNumber);
            this.complaintNumber -= 1;
          }
        }
      }
    },
    multipleCases: function (newVal) {
      this._data.singleCase = !newVal;
    },
  },
  mounted() {
    this.onLanguageSelect();
    this.$watch(
      () => {
        return this.$refs.inspectionTime.inputDate;
      },
      (newVal) => {
        this.inspectionTimeInputDate = newVal;
        this.$v.form.inspectionTime.$touch();
      }
    );
    this.$watch(
      () => {
        return this.$refs.caseDueDate.inputDate;
      },
      (newVal) => {
        this.caseDueDateInputDate = newVal;
        if (!newVal) {
          this.form.caseDueDate = null;
          this.$v.form.caseDueDate.$reset();
        }
        this.$v.form.caseDueDate.$touch();
      }
    );
  },
  methods: {
    hackValidateDate(refName) {
      const datepicker = this.$refs[refName];
      if (!datepicker) return true; // field validated and sent out, but something is really wrong
      const inputDate = datepicker.inputDate;
      const parsedInput = dayjs(inputDate, "DD.MM.YYYY", true);
      return parsedInput.isValid();
    },
    // captcha functions
    onSubmit: function () {
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: function (response) {
      console.log("Verify: " + response);
    },
    onExpired: function () {
      console.log("Expired");
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },

    onObjectSelect(object) {
      if (object === "notInList") {
        this.showObjectName = true;
      } else {
        this.showObjectName = false;
      }
    },

    onLanguageSelect(language) {
      // First, check if there's a preferred language
      if (!language) {
        const preferredLanguage = getPreferredLanguage();

        if (preferredLanguage) language = preferredLanguage
      }

      // Then, check the local storage for the language
      if (!language) {
        if (localStorage.getItem("language")) {
          console.log(`Got ${localStorage.getItem("language")} from local storage.`)
          language = localStorage.getItem("language");
        }
      }

      // Finally, if there's still no language, let's just default it to Estonian.
      if (!language) language = "ET"

      this.selectedLanguage = language;
      switch (language) {
        case "ET":
          this.languageLibrary = i18nET;
          break;
        case "EN":
          this.languageLibrary = i18nEN;
          break;
        case "RU":
          this.languageLibrary = i18nRU;
          break;
        case "LV":
          this.languageLibrary = i18nLV;
          break;
        default:
          this.languageLibrary = i18nET;
          this.selectedLanguage = "ET";
          break;
      }
      this.$material.locale.dateFormat = "dd.MM.yyyy";
      this.$material.locale.firstDayOfAWeek = "1";
      this.$material.locale.shorterDays = this.languageLibrary.shorterDays;
      this.$material.locale.shortDays = this.languageLibrary.shortDays;
      this.$material.locale.months = this.languageLibrary.months;
      this.$material.locale.shortMonths = this.languageLibrary.shortMonths;
      this.$material.locale.cancel = this.languageLibrary.cancel;
      localStorage.setItem("language", language);
    },

    /**
     * Set error class to field if field is not valid
     */
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    /**
     * Get form data
     */
    saveForm() {
      let data = {
        language: this.selectedLanguage,
        rooms: [],
      };
      this.sending = true;
      const phone = this.form.region + " " + this.form.phoneNr;
      Object.keys(this.form.complaintRows).forEach((key) => {
        let projectName = this.form.project;
        if (projectName == "notInList" && this.form.objectName) {
          projectName = this.form.objectName;
        }
        let delivery_date = "";
        if (this.form.caseDueDate) {
          delivery_date = this.getIsoDate(this.form.caseDueDate);
        }

        const obj = {
          project:
            projectName === "notInList"
              ? "Nimistus mitte olev objekt"
              : projectName,
          apartment_nr: this.form.apartmentNr,
          sender_name: this.form.fullName,
          sender_email: this.form.email,
          sender_phone: phone,
          inspection_time: this.getIsoDate(this.form.inspectionTime),
          delivery_date,
          task_date: this.getIsoDate(new Date()),
          room_name:
            i18nET[this.form.complaintRows[key].roomName] ??
            this.form.complaintRows[key].roomName,
          description: this.form.complaintRows[key].description,
          files: this.form.complaintRows[key].files,
        };
        data.rooms.push(obj);
      });
      this.sendReport(data);
    },
    getIsoDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const days = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const second = date.getSeconds();

      const utc = new Date(year, month, days, hours, minutes, second, 0);
      utc.setUTCFullYear(year);
      utc.setUTCMonth(month);
      utc.setUTCDate(days);
      utc.setUTCHours(hours);
      utc.setUTCMinutes(minutes);
      utc.setUTCSeconds(second);

      return utc.toISOString();
    },
    sendReport(report) {
      appService
        .sendReport(report)
        .then((data) => {
          console.log("saveForm ->  data", data);
          localStorage.setItem("formSaved", "true");
          console.log("TCL: sendReport -> report", report);
          this.$emit("form-submitted", true);
          this._data.showDialog = true;
        })
        .catch(() => window.alert(this.languageLibrary.genericError));
    },
    /**
     * Validate form, send info to child componentif it has invalid fields
     */
    validateForm() {
      Object.keys(this.form.complaintRows).forEach((key) => {
        if (
          this.form.complaintRows[key].roomName === "" ||
          this.form.complaintRows[key].description === ""
        ) {
          if (this.emptyRows.indexOf(key) === -1) this.emptyRows.push(key);
        } else if (
          this.form.complaintRows[key].roomName !== "" &&
          this.form.complaintRows[key].description !== ""
        ) {
          if (this.emptyRows.indexOf(key) > -1)
            this.emptyRows = this.emptyRows.filter(function (item) {
              return item !== key.toString();
            });
        }
      });
      this.$v.$touch();
      if (!this.$v.$invalid && this.emptyRows.length === 0) {
        this.saveForm();
      }
    },
    // START Validation functions for fields
    checkApartmentError() {
      this.$v.form.apartmentNr.$touch();
    },
    checkNameError() {
      this.$v.form.fullName.$touch();
    },
    checkObjectNameError() {
      this.$v.form.objectName.$touch();
    },
    checkInspectionError() {
      this.$v.form.inspectionTime.$touch();
    },
    checkCaseDueDateError() {
      this.$v.form.caseDueDate.$touch();
    },
    checkPhoneError() {
      this.$v.form.phoneNr.$touch();
    },
    checkEmailError() {
      this.$v.form.email.$touch();
    },
    // END Validation functions for fields
    /**
     * Get calling codes
     */
    getReport() {
      appService.getCountries().then((data) => {
        data.forEach((elem) => {
          const finalCallingCode =
            `${elem.idd.root}${elem.idd.suffixes[0]}`.replace("+", "");
          if (
            finalCallingCode &&
            finalCallingCode.length > 0 &&
            !isNaN(finalCallingCode) &&
            this.regions.includes(parseInt(finalCallingCode)) === false
          ) {
            this.regions.push(parseInt(finalCallingCode.replace(/\s+/g, "")));
          }
        });
        this.regions.sort();
      });
    },
    /**
     * add complaint rows to form
     */
    addComplaintRow: function () {
      this.complaintNumber += 1;
      this.form.complaintRows[this.complaintNumber] = {
        roomName: "",
        description: "",
      };
    },
    /**
     * Delete complaint row and row index from errors array
     * @param index {number} - row index
     */
    deleteComplaint: function (index) {
      if (index !== undefined) {
        this.emptyRows = this.emptyRows.filter(function (item) {
          return item !== index.toString();
        });
        delete this.form.complaintRows[index];
      }
    },
    /**
     * Add complaint rows to form
     * @param data {obj} - row fields
     * @param index {number} - row index
     */
    updateForm: function (data, index) {
      this.form.complaintRows[index] = data.record;
    },
    /**
     * Translates a string
     * @param {string} key The string to be translated
     */
    _: function (key) {
      const translatedString = this.languageLibrary[key];
      if (!translatedString) return key;
      return translatedString;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
#submitButton {
  white-space: nowrap;
  display: inline-block;
  border-radius: 5px;
  padding: 5px 15px;
  font-size: 20px;
  color: white;
  background-image: linear-gradient(#4f93ce, #285f8f);
  border: 1px solid #285f8f;
  margin-top: 25px;
  margin-bottom: 20px;
}
.mr-left-10 {
  margin-left: 10px;
}
.mr-right-10 {
  margin-right: 10px;
}
.md-progress-bar {
  position: absolute;
  /* top: 0; */
  right: 0;
  left: 0;
  margin-top: 10px;
}
.md-card .md-title {
  font-size: 30px;
  line-height: 32px;
  font-weight: bold;
}
/*
.md-file .md-file-icon {
  display: none !important;
} */
.files-container {
  margin-top: 20px;
}
.file-input {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.complaint-header {
  text-align: left;
  padding-left: 5px;
  margin-block-start: 0em;
  margin-bottom: 5px;
}
.complaint-helptext {
  text-align: left;
  display: block;
}
.next-complaint-btn {
  margin-left: 0;
  margin-bottom: 15px;
}
.md-icon {
  color: white !important;
  margin-right: 7px;
}
.checkbox {
  margin-left: 20px;
}
.top-margin {
  margin-top: 15px;
}
.checkbox:last-of-type {
  margin-top: -5px;
}
.md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  background-color: #fc8c03 !important;
  background-color: var(--md-theme-default-accent, #fc8c03) !important;
  border-color: #fc8c03 !important;
  border-color: var(--md-theme-default-accent, #fc8c03) !important;
}
.md-card-actions {
  margin-right: 16px;
  padding: 0px;
  display: flex;
  align-items: center;
}
:deep(.md-dialog-container) {
  padding: 20px;
}
.dialog button {
  width: 60px;
  position: absolute;
  right: 0;
  bottom: 0;
  margin: 15px 20px;
}
.errorMsg {
  color: red;
  margin-top: -22px;
  font-size: 12px;
  display: block;
  width: fit-content;
}
.hidden {
  display: none;
}
.datepickerError.md-field.md-theme-default:after {
  background-color: red !important;
}
.hidden {
  display: none;
}
.show {
  display: block;
}
.next-complaint-btn {
  border: 1px solid gray;
}
.before-send-helptext {
  text-align: right;
  margin-right: 16px;
}

.md-header {
  display: grid;
}

@media (min-width: 768px) {
  .md-header {
    grid-template-columns: 1fr;
  }
}

.custom-layout {
  gap: 8px;
}
</style>
